import { create } from 'zustand';
import { devtools, subscribeWithSelector } from 'zustand/middleware';

import { createSelectors } from '../helpers';
import { useAuthSlice } from './slices/auth/useAuthSlice';
import { useAddonsSlice } from './slices/useAddonsSlice';
import { useAvatarSlice } from './slices/useAvatarSlice';
import { useBonanzaPromoSlice } from './slices/useBonanzaPromoSlice';
import { useFortuneWheelSlice } from './slices/useFortuneWheelSlice';
import { useGameSlice } from './slices/useGameSlice';
import { usePlayerSlice } from './slices/usePlayerSlice';
import { useRealTimeServiceSlice } from './slices/useRealTimeServiceSlice';
import { useReferralPageSlice } from './slices/useReferralPage';
import { useScratchGameSlice } from './slices/useScratchGameSlice';
import { useTechInfoSlice } from './slices/useTechInfoSlice';
import { useTopSpotGameSlice } from './slices/useTopSpotGameSlice';
import { useTournamentsSlice } from './slices/useTournamentsSlice';
import { CommonStoreType } from './types';

const useCommonStoreBase = create<CommonStoreType>()(
  devtools(
    subscribeWithSelector((...a) => {
      return {
        ...useTechInfoSlice(...a),
        ...usePlayerSlice(...a),
        ...useAuthSlice(...a),
        ...useAddonsSlice(...a),
        ...useGameSlice(...a),
        ...useAvatarSlice(...a),
        ...useRealTimeServiceSlice(...a),
        ...useTournamentsSlice(...a),
        ...useTopSpotGameSlice(...a),
        ...useBonanzaPromoSlice(...a),
        ...useScratchGameSlice(...a),
        ...useReferralPageSlice(...a),
        ...useFortuneWheelSlice(...a),
      };
    }),
    { name: 'useCommonStore', enabled: false }
  )
);

export const useCommonStore = createSelectors(useCommonStoreBase);
